import API from '@/views/Fdc/Apis/'

/**
 * Admin > EQP Alarm Manager
 * EQP Alarm Master 관리
 */
export default {
  name: 'EqpAlarmManager',
  components: {
  },
  watch: {
  },
  beforeMount () {
    this.initColumns()
    this.getCodeList()
  },
  mounted () {
  },
  methods: {
    /**
     * Column initialize
     */
    initColumns () {
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', width: 100, required: true, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 150, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM_ID'), field: 'alarmId', width: 150, required: true, editable: true, modifiable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM_CODE'), field: 'alarmCode', width: 150, required: true, editable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM_SEVERITY'), field: 'alarmSeverity', width: 150, required: true, editable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM_TEXT'), field: 'alarmText', width: 300, required: true, editable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.AUTO_SAVE'), field: 'autoSaveYn', width: 120 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 170, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110 }
      ]
    },
    /**
     * Code 조회
     */
    async getCodeList () {
      let payload = { codeType: 'ALARM_SEVERITY' }
      await API.Common.getCodes(payload, this.getCodeListCallback)
    },
    getCodeListCallback (response) {
      if (response.status === 200 && response.data) {
        this.severityList = response.data.map(d => d.codeId)
        // ALARM_SEVERITY
        this.columns.map(c => {
          if (c.field === 'alarmSeverity') {
            c.cellEditor = 'agSelectCellEditor'
            c.cellEditorParams = {
              values: this.severityList
            }
          }
          return c
        })
        this.$refs.eqpAlarmManagerGrid.gridApi.setColumnDefs(this.columns)
      }
    },
    /**
     * EQP Alarm Manager 목록 조회
     * @param {String} fab Fab
     * @param {String} eqpId eqpId
     */
    async listFn (fab, eqpId) {
      let payload = {
        fab: fab,
        eqpId: eqpId
      }
      let data = await API.Admin.getEqpAlarms(payload)
      this.rowData = data
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * EQP 목록 검색
     */
    searchProcess () {
      if (this.selectedTreeNode.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Equipment']))
        return
      }

      let node = this.selectedTreeNode
      if (node.detail.eqpId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP ID']))
        return
      }

      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      this.listFn(node.detail.fab, node.detail.eqpId)
    },
    /**
     * EQP Alarm Manager Grid에 check된 row count 확인
     * @returns {Boolean} check된 row가 있는지 여부
     */
    hasCheckedRows () {
      if (!this.$refs.eqpAlarmManagerGrid) {
        return 0
      }
      return this.$refs.eqpAlarmManagerGrid.checkedRowCount > 0
    },
    /**
     * Add Button 활성화 여부 결정
     * @returns {Boolean} Add Button 활성화 여부
     * 검색된 tree node 있는지 여부를 판단하여 Add Button 활성화 여부를 결정합니다.
     */
    addEnable () {
      if (!this.searchTreeNode.detail) {
        return false
      } else {
        let selectEqpVo = this.searchTreeNode.detail
        if (selectEqpVo.fab !== null &&
          selectEqpVo.eqpId !== null) {
          return true
        }
        return false
      }
    },
    /**
     * EQP Alarm Manager Grid 재조회
     */
    refreshGrid () {
      if (this.searchTreeNode && this.searchTreeNode.length !== 0) {
        let selectEqpVo = this.searchTreeNode.detail
        this.listFn(selectEqpVo.fab, selectEqpVo.eqpId)
      }
    },
    /**
     * EQP Alarm Master 저장
     */
    async saveData () {
      const valid = this.saveValidCheck(this.$refs.eqpAlarmManagerGrid)
      if (valid.inValid) {
        return false
      }
      let confirmMessage = ''
      if (!_.isEqual(valid.saveRows.length, valid.totalModifiedRows.length)) {
        confirmMessage = this.$t('fdc.COMMON.MESSAGE.CONFIRM_UNCHECKED_CHANGED_DATA')
      }
      confirmMessage += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

      const that = this
      let payload = {
        dataList: valid.saveRows
      }
      this.$buefy.dialog.confirm({
        message: confirmMessage,
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        onConfirm: async function () {
          const responseData = await API.Admin.saveEqpAlarms(payload)
          if (responseData != null && responseData.status === 200) {
            that.$buefy.dialog.alert(that.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
            that.refreshGrid()
          } else {
            that.$buefy.dialog.alert(that.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
          }
        }
      })
    },
    /**
     * Save Validation 체크 및 Data 생성
     * @param {*} grid
     * @returns {*} Validation 성공 여부, save row data, modify row data
     */
    saveValidCheck (grid) {
      const checkedRows = grid.getCheckedRows()
      const addedRows = grid.getAddedRows()
      const updatedRows = grid.getUpdatedRows()
      let totalModifiedRows = []
      totalModifiedRows.push(...addedRows)
      totalModifiedRows.push(...updatedRows)
      let saveRows = []

      let result = {
        inValid: false,
        saveRows: saveRows,
        totalModifiedRows: totalModifiedRows
      }

      // 선택된 데이터가 없습니다.
      if (checkedRows.length < 1) {
        this.$buefy.dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
        result.inValid = true
        return result
      }

      checkedRows.some(row => {
        const rowStatus = row.briqueGridCud
        // 변경되어 선택된 저장 대상
        if (rowStatus === 'C' || rowStatus === 'U') {
          saveRows.push(row)
        }
      })

      // 변경된 데이터가 없습니다.
      if (saveRows < 1) {
        this.$buefy.dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_CHANGED'))
        result.inValid = true
        return result
      }

      if (this.saveDataValidCheck(checkedRows, grid)) {
        result.inValid = true
        return result
      }

      return result
    },
    /**
     * 컬럼 필수 저장 값 check
     * @param {*} checkedRows check된 row data
     * @param {*} grid BRIQUE grid
     * @returns {Boolean} 체크 결과
     */
    saveDataValidCheck (checkedRows, grid) {
      // BRIQUE Grid
      const that = this
      return checkedRows.some(row => {
        const checkRequired = Object.keys(row).some(function (itemKey) {
          const column = grid.gridColumnApi.getColumn(itemKey)
          if (column != null) {
            const colDef = column.colDef
            const colValue = row[itemKey]
            if (colDef != null && colDef.required && that.isEmpty(colValue)) {
              that.tParam = [colDef.headerName]
              that.$buefy.dialog.alert(that.T.M001)
              return true
            }
          }
        })
        // 필수값
        if (checkRequired) { return true }
        // 중복값
        var dupIdx = this.rowItemDupCheck(row, grid)
        if (dupIdx > 0) {
          this.$buefy.dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['line : ' + dupIdx]))
          return true
        }
      })
    },
    /**
     * 중복 체크
     * @param {*} item row data
     * @param {*} grid BRIQUE Grid
     * @returns {Boolean} 중복 체크 결과
     */
    rowItemDupCheck (item, grid) {
      let dupIdx = 0
      grid.getAllRows().some((row, idx) => {
        switch (grid.briqueGridId) {
          case 'BriqueGrideqpAlarmManagerGrid':
            if (this.itemDupCheck(item, row)) {
              dupIdx = idx + 1
              return true
            }
            break
        }
      })
      return dupIdx
    },
    /**
     * null 값 check
     * @param {*} value check value
     */
    isEmpty (value) {
      if (value === '' || value === null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
        return true
      } else {
        return false
      }
    },
    /**
     * 중복 체크
     * @param {*} item row data (저장 항목)
     * @param {*} row row data (기존 항목)
     * @returns {Boolean} 중복 체크 결과
     */
    itemDupCheck (item, row) {
      return !_.isEqual(item, row) && item.fab === row.fab && item.eqpId === row.eqpId && item.alarmId === row.alarmId
    },
    /**
     * EQP Alarm Master 삭제
     */
    deleteData () {
      const rowList = this.deleteDataCollector(this.$refs.eqpAlarmManagerGrid)
      const that = this
      if (rowList.checkedRows < 1) {
        this.$buefy.dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
      }

      const confirmMessage = this.$t('fdc.COMMON.MESSAGE.CONFIRM_DELETE')
      const completeMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE')

      let payload = {
        dataList: rowList.deleteRow
      }

      this.$buefy.dialog.confirm({
        message: confirmMessage,
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        onConfirm: async function () {
          this.rowData = []
          if (rowList.deleteRow.length > 0) {
            await API.Admin.deleteEqpAlarms(payload)
          }
          that.$buefy.dialog.alert(completeMessage)
          that.refreshGrid()
        }
      })
    },
    /**
     * Row Data 분류
     * @param {*} grid brique grid
     * @returns {*} data Object
     * grid에 row를 분류한다. (check row, add한 row, delete row)
     */
    deleteDataCollector (grid) {
      const checkedRows = grid.getCheckedRows()
      const addedRows = grid.getAddedRows()
      const deleteRows = checkedRows.filter(d => !(d.briqueGridCud === 'C') || !d.briqueGridCud)

      return {
        checkedRows: checkedRows,
        addedRow: addedRows,
        deleteRow: deleteRows
      }
    },
    /**
     * Csv Export
     * 조회된 결과를 Excel 파일로 저장합니다.
     */
    exportCsv () {
      // this.$refs.eqpAlarmManagerGrid.exportExcel('EqpManager')
      this.$refs.eqpAlarmManagerGrid.gridApi.exportDataAsCsv({
        fileName: 'EqpAlarmManager.csv'
      })
    },
    /**
     * EQP Alarm Manager Grid에 check된 row count가 1개인지 확인
     * @returns {Boolean} check된 1개인지 여부
     * Edit 가능 여부에 대해서 판단하여 button 활성화 값이 달라집니다.
     */
    hasOneCheckedRow () {
      if (!this.$refs.eqpAlarmManagerGrid) {
        return 0
      }
      return this.$refs.eqpAlarmManagerGrid.checkedRowCount === 1
    },
    /**
     * Add row
     */
    addRow () {
      let searchEqpVo = this.searchTreeNode.detail
      let obj = {
        fab: searchEqpVo.fab,
        eqpId: searchEqpVo.eqpId,
        alarmSeverity: 'WARNING',
        autoSaveYn: 'N',
        addRow: true
      }
      this.$refs.eqpAlarmManagerGrid.addRowOne(obj)
    },
    /**
     * Edit Button click event
     * check된 row가 없는 상태에서 click 시 alert를 띄웁니다.
     */
    clickDisabledEditButton () {
      if (this.$refs.eqpAlarmManagerGrid.checkedRowCount !== 1) {
        this.$dialog.alert('Check a row to edit Eqp')
      }
    }
  },
  data () {
    return {
      eqpAlarmManagerGrid: null, // EQP Alarm Manager Grid 객체
      severityList: [],
      columns: [], // grid column 배열
      defaultColDef: {
        // minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      rowData: [], // grid row data
      selectedTreeNode: [], // 선택된 EQP Tree node
      searchTreeNode: [] // 검색한 EQP Tree node
    }
  }
}
